import { useState } from 'react';
import { gql, useQuery } from '@apollo/client';

export const GET_EMAIL_TEMPLATES = gql`
  query getEmailTemplates($companyId: String!, $queryOptions: QueryOptionsInput) {
    getEmailTemplates(companyId: $companyId, queryOptions: $queryOptions) {
      collection {
        _id
        subject
        body
        createdBy
      }
      totalCount
    }
  }
`;

export const useGetEmailTemplates = (companyId?: string) => {
  const [currentPage, setPage] = useState(1);

  const pageSize = 4;
  const { data, loading } = useQuery(GET_EMAIL_TEMPLATES, {
    variables: {
      companyId,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
      },
    },
    skip: !companyId,
    fetchPolicy: 'network-only',
  });

  const getEmailTemplates = data?.getEmailTemplates || {};

  return {
    emailTemplates: getEmailTemplates?.collection || [],
    loading,
    paginationConfig: {
      total: getEmailTemplates?.totalCount || 0,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
  };
};

export const useGetEmailTemplatesForList = (companyId?: string) => {
  const { data, loading } = useQuery(GET_EMAIL_TEMPLATES, {
    variables: {
      companyId,
    },
    skip: !companyId,
    fetchPolicy: 'network-only',
  });

  return {
    emailTemplates: data?.getEmailTemplates?.collection || [],
    loading,
  };
};
